import type { JSX, ReactNode } from 'react';

import { cn } from '../lib/cn.js';
import { IconArrowRight } from '../icons/index.js';
import { ChampAvecMentions } from './ChampAvecMentions.js';
import type { EntreeDeMention } from './mentions.js';

export interface BarreDeSaisieProps {
  /** Le texte STOCKE, comme `ChampAvecMentions`. */
  value: string;
  onChange: (texteStocke: string) => void;
  entrees: readonly EntreeDeMention[];
  onEnvoyer: () => void;
  /** Le bouton d'envoi est actif. */
  peutEnvoyer: boolean;
  placeholder?: string | undefined;
  ariaLabel: string;
  autoFocus?: boolean | undefined;
  disabled?: boolean | undefined;
  maxLength?: number | undefined;
  lignesMax?: number | undefined;
  /** Remplace le bouton d'envoi (le bouton « Arreter » de Lia pendant qu'elle repond). */
  action?: ReactNode;
  className?: string | undefined;
}

/**
 * LA BANDE DE SAISIE UNIQUE DU SOCLE : le champ a mentions, a hauteur
 * automatique, et le bouton rond d'envoi aligne sur sa derniere ligne. Un seul
 * comportement pour toutes les surfaces de message (canaux, directs, chatters,
 * Lia, Canaux) : aucune ne recalcule sa hauteur ni ne redessine son bouton.
 */
export function BarreDeSaisie({
  value, onChange, entrees, onEnvoyer, peutEnvoyer, placeholder, ariaLabel, autoFocus, disabled, maxLength, lignesMax, action, className,
}: BarreDeSaisieProps): JSX.Element {
  return <div data-composeur-champ className={cn('taki-champ-de-saisie flex items-end gap-2', className)}>
    <ChampAvecMentions
      value={value}
      onChange={onChange}
      entrees={entrees}
      onEnvoyer={onEnvoyer}
      placeholder={placeholder}
      ariaLabel={ariaLabel}
      autoFocus={autoFocus}
      disabled={disabled}
      maxLength={maxLength}
      lignesMax={lignesMax}
    />
    {action ?? <button type="button" onClick={onEnvoyer} disabled={!peutEnvoyer} aria-label="Envoyer le message" title="Envoyer le message"
      className="relative mb-[1px] flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent text-accent-label disabled:bg-surface-3 disabled:text-ink-400 focus-visible:shadow-ring after:absolute after:-inset-1.5 after:content-['']">
      <span aria-hidden="true" className="-rotate-90"><IconArrowRight size={14} /></span>
    </button>}
  </div>;
}
